<template>
  <div>
    <b-form-radio-group v-model="selected">
      <b-row>
        <b-col class="col-md-4">
          <b-form-radio value="Create120To340Transaction">
            {{ $t("closingEntries.create_120To340_invoice") }}
          </b-form-radio>
        </b-col>

        <b-col class="col-md-4">
          <b-form-radio value="Create340To120Transaction">
            {{ $t("closingEntries.create_340To120_invoice") }}
          </b-form-radio>
        </b-col>

        <b-col class="col-md-4">
          <b-form-radio value="CreateMaTransactionFor6Accounts">
            {{ $t("closingEntries.deploy_including_six_accounts") }}
          </b-form-radio>
        </b-col>

        <b-col class="col-md-4">
          <b-form-radio value="CreateMaTransactionFor7Accounts">
            {{ $t("closingEntries.deploy_including_seven_accounts") }}
          </b-form-radio>
        </b-col>

        <b-col class="col-md-4">
          <b-form-radio value="CreateZZTransaction">
            {{ $t("closingEntries.create_zz_invoice") }}
          </b-form-radio>
        </b-col>

        <b-col class="col-md-4">
          <b-form-radio value="CreateAATransaction">
            {{ $t("closingEntries.create_aa_invoice") }}
          </b-form-radio>
        </b-col>
        

        <b-col class="col-md-12 text-right">
          <b-button variant="primary" :disabled="selected === null" @click="execClosingEntries(selected)">
            {{ $t("others.apply_button") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form-radio-group>
  </div>
</template>

<script>
export default {
  props: {
    subsidiaryLedgerId: {
      type: Number,
    }
  },
  data() {
    return {
      employeeId: localStorage.getItem("EmployeeId"),
      selected: null,
    };
  },
  methods: {
    async execClosingEntries(action) {
      const result = await this.$BasicConfirm();
      if (result.isConfirmed) {
        const controller = {
          name: "AccountingTransaction",
          actionName: action,
        };
        const data = {
          subsidiaryLedgerId: this.subsidiaryLedgerId,
          employeeId: this.employeeId,
        };
        const payload = { data: data, controller: controller };
        const response = await this.$store.dispatch(
          "moduleAuth/customService",
          payload,
        );
        if (response.data.resultStatus == true) {
          this.selected = null;
          this.$BasicAlert();
        } else {
          this.$WarningAlert(response.data.resultMessage);
        }
      }
    }
  },
};
</script>
